import CustomTextField from '../../../../../CustomTextInput';
import Signature from '../../../../../signature/signature';
import {
    BillOfLaden,
    BillOfLadenFormErrors
} from '../../../../../../interfaces/BillOfLaden';
import { NumberInput } from '../../../../../paymentinput/paymentinput';

interface BillOfLadenStepTwoFormProps {
    updateField: (name: string, value: string | number) => void;
    payload: BillOfLaden;
    errors: BillOfLadenFormErrors;
    setSignatureUrlBase64: (value: string) => void;
    signatureUrlBase64: string;
}

const StepTwo = ({
    updateField,
    payload,
    errors,
    setSignatureUrlBase64,
    signatureUrlBase64
}: BillOfLadenStepTwoFormProps) => {
    return (
        <div className='w-full flex flex-col gap-4'>
            <CustomTextField
                required
                id='housebilloflading-sealNumber'
                label='Seal No'
                name='sealNumber'
                value={payload.sealNumber}
                onChange={(e) => {
                    updateField('sealNumber', e.target.value);
                }}
            />

            <CustomTextField
                required
                id='housebilloflading-kindOfPackages'
                label='Package Kind'
                name='kindOfPackages'
                value={payload.kindOfPackages}
                onChange={(e) => {
                    updateField('kindOfPackages', e.target.value);
                }}
            />

            <CustomTextField
                required
                id='housebilloflading-totalGrossWeight'
                label='Gross Weight'
                name='totalGrossWeight'
                value={payload.totalGrossWeight}
                InputProps={{
                    inputComponent: NumberInput,
                    inputProps: {
                        min: '0'
                    }
                }}
                numericInput
                onChange={(e) => {
                    updateField('totalGrossWeight', e.target.value);
                }}
            />

            <CustomTextField
                required
                id='housebilloflading-measurement'
                label='Measurement'
                name='measurement'
                value={payload.measurement}
                onChange={(e) => {
                    updateField('measurement', e.target.value);
                }}
            />

            <CustomTextField
                error={errors?.deliveryAgent.length > 0}
                helperText={
                    errors?.deliveryAgent.length > 0
                        ? errors?.deliveryAgent
                        : undefined
                }
                required
                id='housebilloflading-deliveryAgent'
                label='Delivery Agent'
                name='deliveryAgent'
                value={payload.deliveryAgent}
                onChange={(e) => {
                    updateField('deliveryAgent', e.target.value);
                }}
            />
            <CustomTextField
                error={errors?.freightAmount.length > 0}
                helperText={
                    errors?.freightAmount.length > 0
                        ? errors?.freightAmount
                        : undefined
                }
                required
                id='housebilloflading-freightAmount'
                label='Freight Amount'
                name='freightAmount'
                InputProps={{
                    inputComponent: NumberInput,
                    inputProps: {
                        min: '0'
                    }
                }}
                numericInput
                value={payload.freightAmount}
                onChange={(e) => {
                    updateField('freightAmount', e.target.value);
                }}
            />

            <CustomTextField
                error={errors?.noOfOriginals.length > 0}
                helperText={
                    errors?.noOfOriginals.length > 0
                        ? errors?.noOfOriginals
                        : undefined
                }
                required
                id='housebilloflading-noOfOriginals'
                label='No of Originals'
                name='noOfOriginals'
                value={payload.noOfOriginals}
                numericInput
                InputProps={{
                    inputComponent: NumberInput,
                    inputProps: {
                        min: '0'
                    }
                }}
                onChange={(e) => {
                    updateField('noOfOriginals', e.target.value);
                }}
            />
            <CustomTextField
                error={errors?.placeOfIssue.length > 0}
                helperText={
                    errors?.placeOfIssue.length > 0
                        ? errors?.placeOfIssue
                        : undefined
                }
                required
                id='housebilloflading-placeOfIssue'
                label='Place of Issue'
                name='placeOfIssue'
                value={payload.placeOfIssue}
                onChange={(e) => {
                    updateField('placeOfIssue', e.target.value);
                }}
            />

            <CustomTextField
                error={errors?.freightPayableAt.length > 0}
                helperText={
                    errors?.freightPayableAt.length > 0
                        ? errors?.freightPayableAt
                        : undefined
                }
                required
                id='housebilloflading-freightPayableAt'
                label='Freight Payable At'
                name='freightPayableAt'
                value={payload?.freightPayableAt}
                onChange={(e) => {
                    updateField('freightPayableAt', e.target.value);
                }}
            />

            <Signature
                name='signatureUrl'
                updateField={updateField}
                setSignatureUrlBase64={setSignatureUrlBase64}
                signatureUrlBase64={signatureUrlBase64}
            />
        </div>
    );
};

export default StepTwo;
